import React from "react";
import "./notFound.styles.scss";
function NotFound() {
  return <div>NotFound</div>;
}

export default NotFound;
